module.exports = __webpack_public_path__ + "media/images/mailer/activation_customer/png/startpage_en-2c5255a2a803702a05eecad3517c8bb9.png";